import React, { Component } from 'react';
import config from "../config";
import Referenten from './Referenten'
import ReactModal from 'react-modal';


const customStyles = {
    content: {}
};

class ThemaDetail extends Component{

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render(){
        let {thema} = this.props
        let {selected} = this.props
        let themaId = this.props.thema.id
        let isSelected = this.props.selected.indexOf(themaId) !== -1
        let bgColor = '#fff'
        let margin = '0px'

        if (isSelected) {
            bgColor = '#f5f5f5'
            margin = '10px'
        }

        return <li key={thema.id} className={'list-group-item'} style={{backgroundColor: bgColor}}>
            <div className={'row'} style={{marginBottom: margin}}>
                <div className={'col-md-8'}>
                    <div style={{lineHeight: '34px', cursor: 'pointer'}} onClick={() => this.props.selectThema(thema.id)}>{thema.name}</div>
                </div>
                <div className={'col-md-4'}>
                    <div style={{textAlign: 'right'}}>
                        <span onClick={() => this.props.selectThema(thema.id)} className={'btn btn-default'}><i className={'fas fa-user-circle'}/></span>
                        <span onClick={this.openModal} className={'btn btn-default'}><i className={'fas fa-info-circle'}/></span>
                    </div>
                    <div className={'clearfix'}/>
                </div>
            </div>
            {
                isSelected && <Referenten thema={thema} selected={selected} referenten={this.props.referenten} referentenList={this.props.referenten.list[themaId]}/>
            }

            <ReactModal style={customStyles} isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} contentLabel="Example Modal" appElement={document.getElementById('biwe-referenten')}>
                <div className={'row'}>
                    <div className={'col-xs-2'}>
                        <div className={'detailBbvLogo'}>
                            <img src={config.baseBbvUrl + '/themes/custom/bbv/logo.svg'} alt={'Logo'}/>
                        </div>
                    </div>
                    <div className={'col-xs-10'}>
                        <button onClick={this.closeModal} type="button" className="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </div>
                <hr/>
                <h1>{thema.name}</h1>
                <br />
                <p>{thema.ziel}</p>
            </ReactModal>
        </li>
    }
}

export default ThemaDetail


// WEBPACK FOOTER //
// ./src/components/ThemaDetail.js